export const TAX_INVOICE_SETTINGS_REQUEST = "TAX_INVOICE_SETTINGS_REQUEST";
export const TAX_INVOICE_SETTINGS_SUCCESS = "TAX_INVOICE_SETTINGS_SUCCESS";
export const TAX_INVOICE_SETTINGS_ERROR = "TAX_INVOICE_SETTINGS_ERROR";
export const TAX_INVOICE_SETTINGS_RESET = "TAX_INVOICE_SETTINGS_RESET";

export interface TaxInvoiceSettingsRequest {
  interface: string;
}

export interface TaxInvoiceSettingsResponse {
  result_code: string;
  result_msg: string;
  msg_code: string;
  result_data: {
    settings: {
      ISSUE_TAX?: boolean;
      FORCE_ISSUE_TAX: boolean;
      BOOK_CREDIT_NOTE: string;
      BOOK_TAX_INVOICE: string;
      BOOK_CREDIT_NOTE_MANUAL: string;
      BOOK_TAX_INVOICE_MANUAL: string;
      VAT_ITEM_DESCRIPTION: string;
    };
    enabled: boolean;
  };
}

export interface TaxInvoiceSettingsRequestAction {
  type: typeof TAX_INVOICE_SETTINGS_REQUEST;
  payload: TaxInvoiceSettingsRequest;
}

export interface TaxInvoiceSettingsSuccessAction {
  type: typeof TAX_INVOICE_SETTINGS_SUCCESS;
  payload: {
    data: TaxInvoiceSettingsResponse;
    status: number;
    message: string;
  };
}

export interface TaxInvoiceSettingsErrorAction {
  type: typeof TAX_INVOICE_SETTINGS_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface TaxInvoiceSettingsResetAction {
  type: typeof TAX_INVOICE_SETTINGS_RESET;
}

export type TaxInvoiceSettingsAction =
  | TaxInvoiceSettingsRequestAction
  | TaxInvoiceSettingsSuccessAction
  | TaxInvoiceSettingsErrorAction
  | TaxInvoiceSettingsResetAction;

